
const Index = () => import(/* webpackChunkName: "product-report" */ "./index");
const TransactionList = () => import(/* webpackChunkName: "transaction-report" */ "./TransactionList");

export default [{
  path: 'transaction',
  name: 'transaction',
  component: Index,
  redirect: {
    name: 'transaction-list-report'
  },
  children: [{
    path: 'list',
    name: 'transaction-list-report',
    component: TransactionList,
  }, ],

}, ]